module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0841.7dfeaa40.jpg";